export default __webpack_public_path__ + "static/media/undraw_dev_productivity_umsq.4a50c5d8.svg";